import { usePathname } from "next/navigation";

import { ROUTE_PREFIX } from "../../constants";

export default function useIsSuperNoodle() {
  const pathname = usePathname();

  return pathname.startsWith(`/${ROUTE_PREFIX.CURRICULUMS}`);
}
